import { Component, OnInit } from '@angular/core';
import { MixedLoyaltyItem, PreviewQuery } from '@fgb/core';
import { PreviewItemBase } from '../preview-item.base';

@Component({
  selector: 'fgbcl-preview-reward',
  templateUrl: './preview-reward.component.html',
  styleUrl: './preview-reward.component.scss'
})
export class PreviewRewardComponent extends PreviewItemBase implements OnInit {
  mixedLoyaltyItems: MixedLoyaltyItem[];

  constructor(private previewQuery: PreviewQuery) {
    super()
  }
  ngOnInit(): void {
    this.mixedLoyaltyItems = this.previewQuery.getAllReward();
    this.mixedLoyaltyItems.length >= 3 ? this.setLoop(true) : this.setLoop(false)
  }


}
